import axios from "axios"

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, "")}${path}`
  }
  return path
}

export interface RoleDto {
  roleId: string
  code: string
  displayName: string
  description?: string | null
  isSystem: boolean
  isActive: boolean
  createdAt?: string
  createdBy?: string | null
  updatedAt?: string | null
  updatedBy?: string | null
}

export interface RoleFilter {
  search?: string
  isSystem?: boolean
  isActive?: boolean
  page?: number
  pageSize?: number
}

export interface RoleUpsertRequest {
  code: string
  displayName: string
  description?: string | null
  isActive: boolean
}

export interface RoleUserLookupDto {
  userId: string
  tenantId?: string | null
  fullName?: string | null
  email?: string | null
  phone?: string | null
  username?: string | null
}

export interface RoleUserSearchParams {
  tenantId?: string
  search?: string
  page?: number
  pageSize?: number
}

export interface PagedResultDto<T> {
  items: T[]
  pageNumber: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export async function searchRoles(filter: RoleFilter): Promise<PagedResultDto<RoleDto>> {
  const response = await axios.get<PagedResultDto<RoleDto>>(buildUrl("/api/v1/roles"), { params: filter })
  return response.data
}

export async function createRole(payload: RoleUpsertRequest): Promise<RoleDto> {
  const response = await axios.post<RoleDto>(buildUrl("/api/v1/roles"), payload)
  return response.data
}

export async function updateRole(roleId: string, payload: RoleUpsertRequest): Promise<RoleDto> {
  const response = await axios.post<RoleDto>(buildUrl(`/api/v1/roles/${roleId}`), payload)
  return response.data
}

export async function setRoleActive(roleId: string, isActive: boolean): Promise<void> {
  await axios.patch(buildUrl(`/api/v1/roles/${roleId}/active`), null, { params: { isActive } })
}

export async function getRoleMenus(roleId: string): Promise<string[]> {
  const response = await axios.get<string[]>(buildUrl(`/api/v1/roles/${roleId}/menus`))
  return response.data ?? []
}

export async function updateRoleMenus(roleId: string, menuIds: string[]): Promise<void> {
  await axios.post(buildUrl(`/api/v1/roles/${roleId}/menus`), menuIds ?? [])
}

export async function getUserRoles(userId: string): Promise<string[]> {
  const response = await axios.get<string[]>(buildUrl(`/api/v1/roles/users/${userId}/roles`))
  return response.data ?? []
}

export async function updateUserRoles(userId: string, roleIds: string[]): Promise<void> {
  await axios.post(buildUrl(`/api/v1/roles/users/${userId}/roles`), roleIds ?? [])
}

export async function searchUsersForRole(params: RoleUserSearchParams): Promise<PagedResultDto<RoleUserLookupDto>> {
  const response = await axios.get<PagedResultDto<RoleUserLookupDto>>(buildUrl(`/api/v1/roles/users`), { params })
  return response.data
}
